import React from "react";

type RecordingTimerProps = {
  seconds: number;
};

const pad = (value: number) => String(value).padStart(2, "0");

const RecordingTimer = ({ seconds }: RecordingTimerProps) => {
  const clamped = Math.max(0, Math.floor(seconds));
  const hours = Math.floor(clamped / 3600);
  const minutes = Math.floor((clamped % 3600) / 60);
  const secs = clamped % 60;

  return <span>{`${pad(hours)}:${pad(minutes)}:${pad(secs)}`}</span>;
};

export default RecordingTimer;
